<template>
  <v-card flat class="image-card">
    <v-hover v-if="imageUrl" v-slot:default="{ hover }">
      <v-img class="image-box" :src="imageUrl" contain>
        <v-layout v-if="hover" column fill-height justify-center align-center>
          <v-flex shrink>
            <v-btn @click="imageRemove" color="error" small>Remove</v-btn>
          </v-flex>
          <v-flex class="mt-1" shrink>
            <v-btn @click="openMore" color="purple" dark small>
              <span v-if="imageResult">More Image</span>
              <span v-else>Add Image</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-img>
    </v-hover>

    <v-hover v-else v-slot:default="{ hover }">
      <v-img
        class="image-box"
        src="@/assets/images/NoPhotoAvailable.jpg"
        contain
      >
        <v-layout v-if="hover" column fill-height justify-center align-center>
          <v-flex shrink>
            <v-btn @click="openMore" color="purple" dark small>
              <span v-if="imageResult">More Image</span>
              <span v-else>Add Image</span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-img>
    </v-hover>

    <MoreImage
      :field="field"
      :showDialog="showDialog"
      :imageResult="imageResult"
      @close="showDialog = false"
      @submit="imageChange"
      @uploaded="imageUploaded"
    />
  </v-card>
</template>

<script>
import MoreImage from "@/components/Image/MoreImage";
import productService from "@/modules/Product/service.js";

export default {
  props: ["name", "field", "initUrl"],
  data() {
    return {
      showDialog: false,
      imageUrl: null,
      imageResult: null,
    };
  },
  components: {
    MoreImage,
  },
  watch: {
    initUrl(val) {
      this.imageUrl = val;
    },
    imageUrl(val) {
      if (val) this.$emit("submit", val);
    },
  },
  methods: {
    openMore() {
      this.showDialog = true;
    },
    imageUploaded(val) {
      this.$emit("uploaded", val);
    },
    imageRemove() {
      this.imageUrl = null;
      this.$emit("submit", this.imageUrl);
    },
    getimage(name) {
      return productService
        .getGooglePic({ name: name })
        .then((response) => {
          return response;
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
    imageChange(val) {
      this.imageUrl = val;
      this.showDialog = false;
    },
  },
};
</script>

<style scoped>
.image-card {
  max-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
}

.image-box {
  max-height: 190px;
  object-fit: contain;
}
</style>
